import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "revico-community-talk-details-user" }
const _hoisted_2 = { class: "revico-community-talk-details-user-left" }
const _hoisted_3 = { class: "revico-community-talk-details-user-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" リプライバッジ "),
      _createVNode($setup["ReplyBadge"], {
        badgeType: $props.viewModel.badgeType
      }, null, 8 /* PROPS */, ["badgeType"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode($setup["CommunityTalkUserNickNameProfilePic"], {
        "nick-name": $props.viewModel.nickName,
        "profile-pic-url": $props.viewModel.profilePicUrl
      }, null, 8 /* PROPS */, ["nick-name", "profile-pic-url"]),
      _createVNode($setup["CommunityTalkNewArrivalBadge"], {
        "post-date": $props.postDate,
        "new-arrival-badge-display-days": $props.newArrivalBadgeDisplayDays,
        "new-arrival-badge-text": $props.newArrivalBadgeText
      }, null, 8 /* PROPS */, ["post-date", "new-arrival-badge-display-days", "new-arrival-badge-text"]),
      _createVNode($setup["CommunityTalkUserReviewerAttributeAnswer"], {
        "reviewer-attribute-answers": $props.viewModel.reviewerAttributeAnswers
      }, null, 8 /* PROPS */, ["reviewer-attribute-answers"])
    ])
  ]))
}